var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync, Prop } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BInputGroup, BFormInput } from 'bootstrap-vue';
let MountWidthSelector = class MountWidthSelector extends Vue {
    get invalidFeedback() {
        return `Minimum: ${this.minBorderWidth}mm`;
    }
    isValid(border) {
        return border >= this.minBorderWidth;
    }
    get isTopValid() {
        return this.isValid(this.selectedWidths.top);
    }
    get isBottomValid() {
        return this.isValid(this.selectedWidths.bottom);
    }
    get isLeftValid() {
        return this.isValid(this.selectedWidths.left);
    }
    get isRightValid() {
        return this.isValid(this.selectedWidths.right);
    }
};
__decorate([
    ModelSync('mountWidths', 'change', { type: Object })
], MountWidthSelector.prototype, "selectedWidths", void 0);
__decorate([
    Prop({ type: Number, default: 10 })
], MountWidthSelector.prototype, "minBorderWidth", void 0);
MountWidthSelector = __decorate([
    Component({
        components: {
            BRow, BCol, BFormGroup, BInputGroup, BFormInput
        }
    })
], MountWidthSelector);
export default MountWidthSelector;
